"use client";

import type { AgentTemplate } from "./types";

import { HairlineCardBorder } from "@ui/components/core/HairlineCardBorder";
import { getAgentOrbTexture } from "@ui/components/core/Orb/getAgentOrbTexture";
import { Orb } from "@ui/components/core/Orb/Orb";
import { useAgentTemplatePopup } from "./AgentTemplatePopupContext";

export function CardAgentTemplate({ template }: { template: AgentTemplate }) {
  const { openTemplate } = useAgentTemplatePopup();

  return (
    <button
      type='button'
      onClick={() => openTemplate(template.template_id)}
      className='tw-group tw-relative tw-isolate tw-w-full tw-cursor-pointer tw-overflow-hidden tw-rounded-2xl tw-bg-cream tw-text-left tw-outline-none tw-transition-[background-color,box-shadow] tw-duration-300 tw-ease-out hover:tw-bg-white hover:tw-shadow-[0_0_0_1px_rgba(0,0,0,0.07),_0_2px_4px_0_rgba(0,0,0,0.04)] focus-visible:tw-outline-focus'
      style={{ aspectRatio: "371/464" }}
    >
      <div className='tw-relative tw-z-10 tw-flex tw-h-full tw-flex-col tw-gap-4 tw-p-6'>
        {/* Category */}
        <p className='tw-type-xs tw-shrink-0 tw-text-gray-500'>{template.categoryLabel ?? template.category}</p>

        {/* Orb */}
        <div className='tw-flex tw-flex-1 tw-items-center tw-justify-center'>
          <div className='tw-relative tw-aspect-square tw-w-40 tw-overflow-hidden tw-rounded-full tw-transition-transform tw-duration-300 tw-ease-out group-hover:tw-scale-105'>
            <Orb animated={false} image={{ sizes: "10rem" }} texture={getAgentOrbTexture(template.template_id)} />
          </div>
        </div>

        {/* Footer */}
        <div className='tw-flex tw-shrink-0 tw-flex-col tw-gap-4'>
          <h2 className='tw-type-2xl tw-text-black'>{template.name}</h2>
          <p className='tw-type-xs tw-line-clamp-2 tw-min-h-[2lh] tw-text-gray-500'>{template.description}</p>
        </div>
      </div>

      <HairlineCardBorder roundedClassName='tw-rounded-2xl' />
    </button>
  );
}
